import React from 'react';
import { SHARE_QUESTIONNAIRE_LABEL } from './CombinedShareQuestionnaire';
import { isQuestionnaireSubmitted, loadMarketProfile } from './marketProfileStore';
import MarketDataDemoDashboard from './MarketDataDemoDashboard';

type Props = {
  userEmail: string | null | undefined;
  onClose: () => void;
  onOpenShare: () => void;
};

export default function MarketProfileOnboardingModal({
  userEmail,
  onClose,
  onOpenShare,
}: Props) {
  const state = loadMarketProfile(userEmail);
  const positionSubmitted = isQuestionnaireSubmitted(state.position.status);
  const gradingSubmitted = isQuestionnaireSubmitted(state.grading.status);

  return (
    <div className="dcf-modal-overlay dcf-mp-onboarding-overlay" role="presentation">
      <div
        className="dcf-modal dcf-modal--mp-onboarding"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="mp-onboarding-title"
      >
        <button
          type="button"
          className="dcf-modal__close"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <i className="fas fa-xmark" aria-hidden="true" />
        </button>

        <p className="dcf-mp-onboarding__eyebrow">Мой профиль рынка</p>
        <h2 id="mp-onboarding-title" className="dcf-modal__title dcf-mp-onboarding__title">
          Узнайте, где вы находитесь относительно рынка
        </h2>
        <p className="dcf-mp-onboarding__desc">
          Пройдите опросник по вознаграждению и содержанию своей роли, чтобы узнать:
        </p>
        <ul className="dcf-mp-hero__results dcf-mp-onboarding__results">
          <li>релевантную отраслевую выборку</li>
          <li>точное позиционирование роли на базе её содержания</li>
          <li>детальный анализ вознаграждения в сравнении с рынком</li>
        </ul>

        <MarketDataDemoDashboard />

        <div className="dcf-mp-onboarding__actions">
          {positionSubmitted && gradingSubmitted ? (
            <span className="dcf-mp-hero__step-done">
              <i className="fas fa-check" aria-hidden="true" />
              Анкета отправлена
            </span>
          ) : (
            <button type="button" className="dcf-btn dcf-btn--primary dcf-mp-share-btn" onClick={onOpenShare}>
              {SHARE_QUESTIONNAIRE_LABEL}
            </button>
          )}
        </div>

        <p className="dcf-mp-onboarding__privacy">
          Данные не отображаются в вашем профиле и используются только в обезличенной статистике.
        </p>
      </div>
    </div>
  );
}

export const MARKET_PROFILE_ONBOARDING_SESSION_KEY = 'dc-community-mp-onboarding-shown';

export function isMarketProfileOnboardingNeeded(userEmail?: string | null): boolean {
  try {
    if (sessionStorage.getItem(MARKET_PROFILE_ONBOARDING_SESSION_KEY)) return false;
  } catch {
    return false;
  }
  const state = loadMarketProfile(userEmail);
  const positionDone = isQuestionnaireSubmitted(state.position.status);
  const gradingDone = isQuestionnaireSubmitted(state.grading.status);
  return !positionDone || !gradingDone;
}

export function markMarketProfileOnboardingShown() {
  try {
    sessionStorage.setItem(MARKET_PROFILE_ONBOARDING_SESSION_KEY, '1');
  } catch {
    /* ignore */
  }
}
